
import {ElLoading} from "element-plus";

type column = {
    prop: String;
    label: String;
    width: Number;
};

type parts = {
    name: string;
    mountings_type_pname: string;
    mountings_type_name: string;
    cost_price: number | null;
    selling_price: number | null;
    price_lock: number;
    mountings_brand_name: string;
    specification: string;
    mountings_unit_name: string;
    build_bonus_type: number;
    build_bonus_price: number | null;
    sell_bonus_type: number;
    sell_bonus_price: number | null;
    reappearance_type_name: string;
    describe: string;
    id: number;
};
type partsKey = keyof parts;
type formKey = keyof partsFormType;
let columnList: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件名称",
        width: 164,
    },
    {
        prop: "specification",
        label: "规格",
        width: 75,
    },
    {
        prop: "encoding",
        label: "编码",
        width: 75,
    },
    {
        prop: "stage",
        label: "期初数量",
        width: 75,
    },
    {
        prop: "Purchasewarehousing",
        label: "采购入库",
        width: 75,
    },
    {
        prop: "Returntowarehouse",
        label: "退料入库",
        width: 75,
    },
    // {
    //     prop: "Inventory",
    //     label: "盘盈入库",
    //     width: 75,
    // },
    // {
    //     prop: "materials",
    //     label: "辅料退料入库",
    //     width: 75,
    // },
    // {
    //     prop: "Transfer",
    //     label: "调拨入库",
    //     width: 75,
    // },
    {
        prop: "warehousing",
        label: "其它入库",
        width: 75,
    },
    {
        prop: "Totalwarehousing",
        label: "入库合计",
        width: 75,
    },
    {
        prop: "Picking",
        label: "领料出库",
        width: 75,
    },
    // {
    //     prop: "inventoryloss",
    //     label: "盘亏出库",
    //     width: 75,
    // },
    // {
    //     prop: "auxiliarymaterials",
    //     label: "辅料领料出库",
    //     width: 75,
    // },
    {
        prop: "Returndelivery",
        label: "退货出库",
        width: 75,
    },
    // {
    //     prop: "Transferout",
    //     label: "调拨出库",
    //     width: 75,
    // },
    {
        prop: "salesdelivery",
        label: "配件销售出库",
        width: 75,
    },
    {
        prop: "Otherdelivery",
        label: "其它出库",
        width: 75,
    },
    {
        prop: "Totaldelivery",
        label: "出库合计",
        width: 75,
    },
    {
        prop: "Closingquantity",
        label: "期末数量",
        width: 75,
    }
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {
    getManagementTable,
    getManagementTableAdd,
    getManagementTableEdit,
    getSetManagement,
    getSelectList, partsStockExport, enterPinExport,
} from "@/api/http";



import {Request} from '@/api/request';
import { validateInput, validateClass } from "@/assets/js/formRules";
import { partsFormType } from "@/assets/types/common";
import { useRoute, useRouter } from 'vue-router'
import {getFirstNowLastDay} from "@/api/date";
export default defineComponent({
    name: "enterPin",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(['进销存']);
   
        const headClass = inject("headClass");
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            total = ref(0),
            loading = ref(true),
            type =  ref(''),
            route:any = useRoute(),
            Router:any = useRouter(),
            // 筛选
            selectGroup = reactive({
                status: "",
                build_bonus_price: "",
                return_cash_plan: "",
                mountings_type_pname: "",
                mountings_type_name: "",
                mountings_brand_name: "",
                search:''
            }),
            selectList = ref({
                classificationa: [],
                classificationb: [],
                MountingsBrand: []
            }),
            remote_loading = ref(false),
            screenParameter = ref({
                time: null,
                start_time: null,
                end_time: null,
                search: '',
                page: currentPage.value,
                pagesize: pageSize.value,
                mountings_type_pid:　null,
                mountings_type_id: null,
            } as any),
            dialog_model = ref(''),
            dialogTitle = ref("新增配件"),
            formRef = ref(null),
            form = ref({
                mountings_name: '',
                mountings_id: '',
                mountings_stock: ''
            } as any),
            commissionType = ref(["固定金额", "业绩比例", "毛利比例"]),
            isEdit = ref(false),
            rules = reactive({
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput('请输入配件名称', value, callback);
                        },
                        trigger: "change",
                    },
                ],
                class: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: undefined,
                            callback: Function
                        ) => {
                            validateClass(rule, callback, form);
                        },
                        trigger: "change",
                    },
                ],
				cost_price: [{required: true,message: '必填',trigger: "change"}],
				mountings_type_pid: [{required: true,message: '必填',trigger: "change"}],
                price: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput('请输入成本价', value, callback);
                        },
                        trigger: "change",
                    },
                ],
            });
        let handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                let data;
                let start_time = screenParameter.value.time?Math.floor(new Date(screenParameter.value.time[0]).getTime()/1000):"";
                let end_time = screenParameter.value.time ?Math.floor((new Date(screenParameter.value.time[1]).getTime()+24*60*60*1000-1)/1000):"";
     
                data = {...screenParameter.value,start_time:start_time,end_time:end_time,page: currentPage.value,
                    pagesize: pageSize.value};
                Request.axiosInstance({
                    url: 'adminapi/Warehouse/enterPin',
                    data: data
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0
                    
                })

            },
            getSelectData = (data: {
                search?: string;
                type_pid?: number | null;
            }) => {
                getSelectList(data).then((res: any) => {
                    Object.assign(selectList.value, res?.content || {});
                    remote_loading.value = false;
                });
            },
            selectChange = (e: any, key: string): void => {
                // screenParameter[key] = e;
                if(key == 'mountings_type_pid')
                {
                    screenParameter.value.mountings_type_id = null
                    Request.axiosInstance({
                        url: 'adminapi/MountingsType/list',
                        data: {pid: screenParameter.value.mountings_type_pid}
                    }).then((res: any) => {
                         selectList.value.classificationb = res?.content?.list
                    })
                    return 
                }
                getTableData();
            },
            exportChange = () => {
                const loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
    
                enterPinExport(screenParameter.value).then((res: any) => {
                    loading.close();
                    if (res.status == 200) {
                        const url = res.content;
                        console.log('url-----',url);
                        window.open(url);
                    }
                }).catch(()=>{
                    loading.close();
                });
            },
            remoteBrand = (e: string) => {
                remote_loading.value = true;
                getSelectData({ search: e });
            },
            formSelectChange = (e: number) => {
                getSelectData({ type_pid: e });
                form.value.mountings_type_id = null;
            },
            bonusSelectChange = (type: boolean) => {
                if (type) {
                    form.value.build_bonus_price = null;
                } else {
                    form.value.sell_bonus_price = null;
                }
            },
            brandBlur = (type: boolean) => {
                if (type) {
                    if (!selectGroup.mountings_brand_name) {
                        getSelectData({});
                    }
                } else {
                    if (!form.value.mountings_brand_id) {
                        getSelectData({});
                    }
                }
            },
            screenChange = ( e: any, key: string): void => {
	
			   // if (key == "time") {
               //      screenParameter.value["start_time"] = e ?  (e[0] as Date).getTime() / 1000 : null
               //      screenParameter.value["end_time"] = e? (e[1] as Date).getTime() / 1000 : null
               // }
			    getTableData();
			},
            columnChange = (
                item: partsFormType & { id: number; status: number },
                type: boolean
            ): void => {
                if (type) {
                    dialogTitle.value = "编辑配件";
                    isEdit.value = true;
                    let data: any = { ...form.value, id: 0 };
                    Object.keys(data).forEach((key) => {
                        data[key as formKey] = item[key as formKey];
                    });
                    form.value = data;
                    getSelectData({ type_pid: form.value.mountings_type_pid });
                } else {
                    getSetManagement({
                        id: item.id,
                        status: item.status == 1 ? 0 : 1,
                    }).then((res) => getTableData());
                }
            },
            _submitForm = (): void => {
                
                Request.axiosInstance({
                    url: 'adminapi/Warehouse/partsStockUpWarning',
                    data: form.value
                }).then((res: any) => {
                    if(res.status != 202) return 
                    dialog_model.value = ''
                    getTableData()
                })
            },

            _option = (url: string , data: any) => {
				Router.push({
					path: url,
					query: data
				})
			},
            _purchaseMarkin = (id: number) => {
                Request.axiosInstance({
                    url: 'adminapi/Warehouse/purchaseMarkin',
                    data: {purchase_id: id}
                }).then((res: any) => {
                    getTableData()
                })
            }
        onMounted(() => {
            //当天23:59:59
            let endTime = Math.floor((new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)/1000);
            //当天0点
            let startTime = Math.floor((new Date(new Date().toLocaleDateString()).getTime())/1000);
            //screenParameter.value.start_time = startTime;
            //screenParameter.value.end_time = endTime;
            screenParameter.value.time = [new Date(),new Date()];
        
            Promise.all([
                Request.axiosInstance({
                    url: 'adminapi/MountingsType/list',
                    data: {}
                }),
                Request.axiosInstance({
                    url: 'adminapi/MountingsBrand/list',
                    data: {status: 1}
                })
            ]).then((res: any) => {
                selectList.value.classificationa = res[0]?.content?.list
                selectList.value.MountingsBrand = res[1]?.content?.list
            })
            //getTableData();
            let data = {...screenParameter.value,start_time:startTime,end_time:endTime,page: currentPage.value,
                pagesize: pageSize.value};
            Request.axiosInstance({
                url: 'adminapi/Warehouse/enterPin',
                data: data
            }).then((res: any) => {
                tableData.value = res?.content?.list || [];
                loading.value = false;
                total.value = res?.content?.total || 0
        
            })

        });

        watch(dialog_model, (newval: any, oldval: any) => {
            if(newval == 'warning'){
                form.value.mountings_stock = ''

                console.log(form.value)
            }

        })
        return {
            columnList,
            headClass,
            pageSize,
            currentPage,
            tableData,
            total,
            loading,
            selectGroup,
            selectList,
            remote_loading,
            dialogTitle,
            formRef,
            form,
            commissionType,
            isEdit,
            rules,
            handleSizeChange,
            handleCurrentChange,
            selectChange,
            remoteBrand,
            formSelectChange,
            bonusSelectChange,
            brandBlur,
            columnChange,
            _submitForm,
            type,
            _option,
            _purchaseMarkin,
            screenParameter,
            dialog_model,
            screenChange,
            exportChange
        };
    },
});
